/** @jsx dom */
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _viskanGetEditorClass = require('@viskan/get-editor-class');

var _viskanGetEditorClass2 = _interopRequireDefault(_viskanGetEditorClass);

var propTypes = {
	'class': {
		type: 'string'
	},
	disabled: {
		type: 'boolean'
	},
	name: {
		type: 'string'
	},
	onClick: {
		type: 'function'
	},
	type: {
		type: 'string'
	}
};

var render = function render(_ref) {
	var props = _ref.props;
	var children = props.children;
	var disabled = props.disabled;
	var name = props.name;
	var onClick = props.onClick;
	var type = props.type;
	var styleClasses = props.styleClasses;

	var defaultName = 'Button';

	return (0, _magicVirtualElement2['default'])(
		'button',
		{ 'class': ['Button', props['class'], (0, _viskanGetEditorClass2['default'])(styleClasses, name, defaultName)], 'data-style-attr': name ? name : defaultName, disabled: disabled, name: name, onClick: onClick, type: type },
		children
	);
};

exports['default'] = { propTypes: propTypes, render: render };
module.exports = exports['default'];
